import { rem } from 'polished'
import styled from 'styled-components'

import { InputLabelStyled } from '@ui/blocks/Form'

export const PaginationLabelStyled = styled.span`
  padding-right: ${rem(12)};
  padding-left: ${rem(12)};

  ${InputLabelStyled} {
    font-weight: ${(props) => props.theme.fontWeights.normal};
  }
`
